// extracted by mini-css-extract-plugin
export default {"rating":"rP-z","numberOfStars":"sP-z","count":"tP-z","barGraphSpacing":"uP-z","barGraph":"vP-z"};